import ClubFee from '../../../dto/ClubFee';
import Error from '../../../model/Error';
import axios from 'axios';

export default class OfferingClubFeeRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/club-fees`)
                .then((response) => resolve(response.data.data.map((data) => ClubFee.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
